const contractFeeCount = {
	data: {
		total: 26,
		complete: 2
	},
	errors: []
};

export default contractFeeCount;
